export default "__VITE_ASSET__D$adfx8p__"